import { z } from 'zod';

/**
 * 管理者向け申込更新フォームのバリデーションスキーマ
 *
 * 更新対象: お客様情報、ホテル情報
 * 更新対象外: 空港情報（現時点で空港・カウンターが1つで運用開始のため）
 */
export const adminApplicationUpdateSchema = z
    .object({
        // お客様情報 (customer_info)
        reservationHolderName: z.string().min(1, '宿泊予約者名を入力してください'),
        userName: z.string().min(1, '利用者名を入力してください'),
        relationshipWithGuest: z.string().min(1, '宿泊者との関係を選択してください'),
        email: z.string().min(1, 'メールアドレスを入力してください').email('有効なメールアドレスを入力してください'),
        phoneNumber: z.string().optional(),
        // IntlTelInput コンポーネントの isValidNumber() 結果を検証
        // ※ 関連: shared/ui/IntlTelInput.vue
        isPhoneValid: z.boolean().refine((value) => value === true, '有効な電話番号を入力してください'),
        countryName: z.string().optional(),

        // ホテル情報 (hotel_info)
        hotelId: z.string().min(1, 'ホテルを選択してください'),
        checkInDate: z.string().min(1, 'チェックイン日を入力してください'),
        checkOutDate: z.string().min(1, 'チェックアウト日を入力してください'),
    })
    .refine((data) => !data.checkInDate || !data.checkOutDate || data.checkInDate < data.checkOutDate, {
        message: 'チェックアウト日はチェックイン日より後の日付を選択してください',
        path: ['checkOutDate'],
    });

/**
 * 管理者向け申込更新フォームの型
 */
export type AdminApplicationUpdateForm = z.infer<typeof adminApplicationUpdateSchema>;

/**
 * 管理メモの最大文字数
 */
export const MEMO_MAX_LENGTH = 2000;

/**
 * 管理メモ更新フォームのバリデーションスキーマ
 *
 * 管理メモは申込情報の一括更新とは独立して更新するため、専用スキーマとして定義する
 */
export const applicationMemoSchema = z.object({
    memo: z.string().max(MEMO_MAX_LENGTH, `メモは${MEMO_MAX_LENGTH}文字以内で入力してください`).optional(),
});

/**
 * 管理メモ更新フォームの型
 */
export type ApplicationMemoForm = z.infer<typeof applicationMemoSchema>;
